import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "StandardTable",
  // props: ['bordered', 'loading', 'columns', 'data', 'rowKey', 'pagination', 'selectedRows'],
  props: {
    /**
     * 数据加载函数，返回值必须是 Promise
     * 默认情况下必须传递 data 参数；
     *    如果使用本地数据渲染表格，业务代码中将获取本地数据包装为 Promise 即可。
     *
     * currentData 用于向外暴露表格当前渲染的数据，
     * 业务开发中也可以直接修改 currentData，从而重新渲染表格（仅推荐用于客户端排序、数据过滤等场景）
     */
    data: {
      type: Function,
      required: true
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Array,
      required: true
    },

    /*      pagination: {
            type: Object,
            default () {
              return {}
            }
          },*/
    pageSize: {
      type: Number,
      default: 10
    },
    pageNum: {
      type: Number,
      default: 1
    },
    pageSizeOptions: {
      type: Array,
      default: function _default() {
        return ['10', '20', '30', '40', '50'];
      }
    },
    responseParamsName: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    bordered: {
      type: Boolean,
      default: false
    },

    /**
     * 表格大小风格，default, middle, small
     */
    size: {
      type: String,
      default: 'default'
    },
    rowKey: {
      type: String,
      default: ''
    },
    selectedRows: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      needTotalList: [],
      selectedRowKeys: [],
      loading: true,
      total: 0,
      pageNumber: this.pageNum,
      currentPageSize: this.pageSize,
      defaultCurrent: 1,
      sortParams: {},
      current: [],
      pagination: {},
      paramsName: {}
    };
  },
  created: function created() {
    //数据请求参数配置
    this.paramsName = Object.assign({}, {
      pageNumber: "pageNo",
      pageSize: "pageSize",
      total: "totalCount",
      results: "data",
      sortColumns: "sortColumns"
    }, this.responseParamsName);
    this.needTotalList = this.initTotalList(this.columns); // load data

    this.loadData({
      pageNum: this.pageNumber
    });
  },
  methods: {
    updateSelect: function updateSelect(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      var list = this.needTotalList;
      this.needTotalList = list.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          total: selectedRows.reduce(function (sum, val) {
            return sum + val[item.dataIndex];
          }, 0)
        });
      });
      this.$emit('change', selectedRowKeys, selectedRows);
    },
    initTotalList: function initTotalList(columns) {
      var totalList = [];
      columns.forEach(function (column) {
        if (column.needTotal) {
          totalList.push(_objectSpread(_objectSpread({}, column), {}, {
            total: 0
          }));
        }
      });
      return totalList;
    },
    loadData: function loadData(params) {
      var that = this;
      that.loading = true;
      params = Object.assign({}, params);
      var remoteParams = Object.assign({}, that.sortParams);
      remoteParams[that.paramsName.pageNumber] = params.pageNum || that.pageNumber;
      remoteParams[that.paramsName.pageSize] = params.pageSize || that.currentPageSize;

      if (params.pageNum) {
        that.pageNumber = params.pageNum;
      }

      if (params.pageSize) {
        that.currentPageSize = params.pageSize;
      }

      var dataPromise = that.data(remoteParams);
      dataPromise.then(function (response) {
        if (!response) {
          that.loading = false;
          return;
        }

        var results = response[that.paramsName.results];
        results = results instanceof Array && results || [];
        that.current = results;
        that.$emit("update:currentData", that.current.slice());
        that.$emit("dataloaded", that.current.slice());
        that.total = response[that.paramsName.total] * 1;
        that.pagination = that.pager();
        that.loading = false;
      }, function () {
        // error callback
        that.loading = false;
      });
    },
    // eslint-disable-next-line
    onPagerChange: function onPagerChange(page, pageSize) {
      this.pageNumber = page;
      this.loadData({
        pageNum: page
      });
    },
    onPagerSizeChange: function onPagerSizeChange(current, size) {
      this.currentPageSize = size;
      /*
      if (current === this.pageNumber) this.loadData()
      console.log('page-size-change', current, size)
      */
    },
    onClearSelected: function onClearSelected() {
      this.selectedRowKeys = [];
      this.updateSelect([], []);
    },
    pager: function pager() {
      return {
        total: this.total,
        showTotal: function showTotal(total) {
          return "\u5171\u6709 ".concat(total, " \u6761");
        },
        showSizeChanger: true,
        pageSizeOptions: this.pageSizeOptions,
        pageSize: this.pageSize,
        defaultCurrent: this.defaultCurrent,
        onChange: this.onPagerChange,
        onShowSizeChange: this.onPagerSizeChange
      };
    }
  },
  watch: {
    'selectedRows': function selectedRows(_selectedRows) {
      this.needTotalList = this.needTotalList.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          total: _selectedRows.reduce(function (sum, val) {
            return sum + val[item.dataIndex];
          }, 0)
        });
      });
    }
  }
};